// Tabella FISSA "SOMMINISTRAZIONE FARMACI" per Tabelle Fisse Alunni.
// Varia ogni anno: garantisce/crea il modello dell'anno attivo ed elenca tutti gli
// alunni dell'anno (campi anagrafici auto-compilati) + i campi farmaci editabili.
import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/lib/AuthContext";
import { ModelloDataGrid } from "./TabelleConfigPage";

export default function FarmaciAnnualePage() {
  const { annoCorrente } = useAuth();
  const [modello, setModello] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let stop = false;
    (async () => {
      setLoading(true); setError("");
      try {
        const r = await api.post("/tabelle-config/ensure-somministrazione-farmaci", null,
          { params: annoCorrente ? { anno: annoCorrente } : {} });
        if (!stop) setModello(r.data);
      } catch (e) {
        if (!stop) setError(e.response?.data?.detail || e.message);
      } finally { if (!stop) setLoading(false); }
    })();
    return () => { stop = true; };
  }, [annoCorrente]);

  return (
    <div style={{ padding: 16 }} data-testid="farmaci-annuale-page">
      <div className="sw-breadcrumb">Tabelle Fisse &gt; Somministrazione Farmaci</div>
      {loading && <div className="sw-loading" data-testid="farmaci-loading">Caricamento tabella Somministrazione Farmaci…</div>}
      {error && (
        <div data-testid="farmaci-error" style={{ padding: 16, background: "#ffebee", border: "1px solid #ffcdd2", color: "#c62828", borderRadius: 6 }}>
          Errore: {error}
        </div>
      )}
      {!loading && !error && modello && (
        <ModelloDataGrid key={modello._id} modello={modello} />
      )}
    </div>
  );
}
